import React from "react"
import { Redirect, useLocation } from "react-router-dom"

import { useCustomerInfo } from "@cirrus/common/CustomerInfo"
import { SsoMode } from "@cirrus/common/CustomerInfo/types"

import { useLoginService } from "./LoginService"

export const WithSamlLoginBias = ({ children }) => {
  const location = useLocation()
  const { loginWithSaml } = useLoginService()
  const customerInfo = useCustomerInfo()
  const ssoMode = customerInfo.data?.saml?.ssoMode

  if (location.pathname === "/" && !!customerInfo.data) {

    if (!customerInfo.data.saml.enabled) return <Redirect to="/login"/>

    if (ssoMode === SsoMode.Mixed) return <Redirect to="/saml"/>

    if (ssoMode === SsoMode.Automatic || ssoMode === SsoMode.Enforced) {
      loginWithSaml()
      return null
    }

    return <Redirect to="/login"/>
  }

  return <>{children}</>
}
